import { CtaButton } from '@/feed/Feed.interface'

function FeedPostFrontCta({
  buttons,
  guid,
  sendClickStat,
  className,
  sendInAppEvent
}: {
  buttons: CtaButton[]
  guid: string
  sendInAppEvent: (inAppEvents: { name: string; occurredAt: string }[]) => void
  sendClickStat: ({
    campaignGuid,
    buttonNumber
  }: {
    campaignGuid: string
    buttonNumber: number
  }) => void
  className?: string
}) {
  const generateUrl = (button: CtaButton) => {
    if (button.destinationType === 'card_back') {
      return `pulsate://postBack?guid=${guid}`
    }
    if (button.destinationType === 'dismiss') {
      return 'pulsate://backbtn'
    }
    return (
      button.destinationUrl ??
      (button as { destination?: string }).destination ??
      '#'
    )
  }

  return (
    <div className={`${className} mt-5 flex flex-col gap-3`}>
      {buttons.map((button) => {
        return (
          <a
            onClick={() => {
              if (button.inAppEvents) {
                sendInAppEvent(
                  button.inAppEvents.map((event) => ({
                    name: event.value,
                    occurredAt: new Date().toISOString()
                  }))
                )
              }
              sendClickStat({
                campaignGuid: guid,
                buttonNumber: button.orderNumber
              })
            }}
            href={generateUrl(button)}
            key={button.orderNumber}
            style={{
              backgroundColor: button.btnColor,
              color: button.txtColor
            }}
            className="text-center overflow-hidden text-ellipsis whitespace-nowrap font-semibold pt-2 pb-2 pl-4 pr-4 w-full rounded first:text-white first:bg-green nth-[2]:bg-white nth-[2]:border nth-[2]:border-green nth-[2]:text-green">
            {button.label}
          </a>
        )
      })}
    </div>
  )
}

export default FeedPostFrontCta
